import { forwardRef } from 'react';

interface MistDividerProps {
  variant?: 'top' | 'bottom' | 'both';
  className?: string;
  intensity?: 'light' | 'medium' | 'strong';
}

export const MistDivider = forwardRef<HTMLDivElement, MistDividerProps>(
  ({ variant = 'both', className = '', intensity = 'medium' }, ref) => {
    const opacityMap = { light: '0.3', medium: '0.5', strong: '0.7' };
    const op = opacityMap[intensity];

    return (
      <div ref={ref} className={`relative w-full pointer-events-none ${className}`} aria-hidden="true">
        {(variant === 'top' || variant === 'both') && (
          <div className="absolute top-0 left-0 right-0 h-24 sm:h-32">
            <div
              className="absolute inset-0"
              style={{
                background: `linear-gradient(to bottom, hsl(220 20% 6% / ${op}), transparent)`,
              }}
            />
            <div
              className="absolute inset-0 animate-mist-drift"
              style={{
                background: `radial-gradient(ellipse 80% 50% at 20% 0%, hsl(42 60% 50% / 0.06), transparent),
                             radial-gradient(ellipse 60% 40% at 70% 0%, hsl(260 30% 40% / 0.05), transparent)`,
              }}
            />
          </div>
        )}
        {(variant === 'bottom' || variant === 'both') && (
          <div className="absolute bottom-0 left-0 right-0 h-24 sm:h-32">
            <div
              className="absolute inset-0"
              style={{
                background: `linear-gradient(to top, hsl(220 20% 6% / ${op}), transparent)`,
              }}
            />
            <div
              className="absolute inset-0 animate-mist-drift-reverse"
              style={{
                background: `radial-gradient(ellipse 70% 50% at 80% 100%, hsl(42 60% 50% / 0.06), transparent),
                             radial-gradient(ellipse 50% 40% at 30% 100%, hsl(260 30% 40% / 0.05), transparent)`,
              }}
            />
          </div>
        )}
      </div>
    );
  }
);

MistDivider.displayName = 'MistDivider';
